<template>
  <div class="not-found">
    <h1>404</h1>
    <p>{{ currentPath }}，页面走丢了。。。</p>
  </div>
</template>
<script>
import { hideLoading } from '../services/loading.service';
export default {
  data() {
    return {
      currentPath: '',
    };
  },
  mounted() {
    this.currentPath = this.$route.fullPath;
    hideLoading();
  },
};
</script>
<style lang="scss">
.not-found {
  width: 100%;
  height: 100%;
  background-color: #fff;
  h1,
  p {
    text-align: center;
  }
  h1 {
    font-size: 60px;
  }
}
</style>
